import { cs } from "../../utils/currency";
import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

interface PaymentBreakdownChartProps {
  data: Array<{
    method: string;
    amount: number;
  }>;
}

const COLORS = ["#2563eb", "#93c5fd"];

// Card payments are grouped under "stripe" by the API but shown as Square
export const formatPaymentMethod = (method: string) =>
  (method === "stripe" ? "square" : String(method)).toUpperCase();

const PaymentBreakdownChart: React.FC<PaymentBreakdownChartProps> = ({ data }) => {
  return (
    <div className="h-[280px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data.map((entry) => ({ ...entry, method: formatPaymentMethod(entry.method) }))}
            dataKey="amount"
            nameKey="method"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            label={({ method }) => method}
          >
            {data.map((entry, index) => (
              <Cell key={`${entry.method}-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `${cs()}${Number(value).toFixed(2)}`} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PaymentBreakdownChart;
